module.exports = __webpack_public_path__ + "om-logo.svg?cc9749441442fa4a3978c968f0599bb6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/om-logo.svg
// module id = 73
// module chunks = 0